import { useFeatureValue } from '@growthbook/growthbook-react';

import {
  FeatureVariant,
  GB_FEATURES,
  GBFeatureKey,
} from '~/services/abTests/features';

export const useGrowthbookFeatureValue = <K extends GBFeatureKey>(
  key: K,
): FeatureVariant<K> => {
  return useFeatureValue(
    key,
    GB_FEATURES[key].defaultVariant,
  ) as FeatureVariant<K>;
};

export const useIsGrowthbookTestGroup = (key: GBFeatureKey): boolean => {
  const variant = useGrowthbookFeatureValue(key);

  return variant !== GB_FEATURES[key].variants.control;
};
